import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import {
    FaFile,
    FaFileAlt,
    FaFileSignature,
    FaChartLine,
    FaSearch
} from 'react-icons/fa';

class  TileButton extends Component {
    constructor(...args) {
        super(...args);
    }
    l = this.props.TileType === 'Search' ? '/order-search' : '/order-create'
    render() {
        
        return (
            <div class="card-stats mb-4 mb-xl-0 card" onClick={()=>
                    {
                        this.props.history.push(this.l)
                    }
                }>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <span style={{color: "#0286c2"}}>
                  {this.props.TileType === 'Search' && <FaSearch size={'4rem'} />}
                  {this.props.TileType === 'New' && <FaFile size={'4rem'} />}
                  <span style={{paddingLeft:'15px', fontSize:'20px'}}>{this.props.Menu}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
    }
}

export default withRouter(TileButton) 